export const SUPPLY_BLOCK_CODES = {
  PO_EDIT_FORWARDING: 'PO_EDIT_FORWARDING',
  PO_EDIT_DELIVERY: 'PO_EDIT_DELIVERY',
  PO_EDIT_INVOICE: 'PO_EDIT_INVOICE',
  PO_DELETE_CASE_ASSIGNED: 'PO_DELETE_CASE_ASSIGNED',
  PO_DELETE_FORWARDING: 'PO_DELETE_FORWARDING',
  PO_DELETE_DELIVERY: 'PO_DELETE_DELIVERY',
  PO_DELETE_INVOICE: 'PO_DELETE_INVOICE',
  PO_EDIT_CASE_LINKED_FLOW: 'PO_EDIT_CASE_LINKED_FLOW',
  FWD_DELETE_CASE_ASSIGNED: 'FWD_DELETE_CASE_ASSIGNED',
  FWD_DELETE_LINKED_ORDER_DELIVERIES: 'FWD_DELETE_LINKED_ORDER_DELIVERIES',
  QE_EDIT_CASE_HAS_ORDER: 'QE_EDIT_CASE_HAS_ORDER',
  QE_DELETE_CASE_ASSIGNED: 'QE_DELETE_CASE_ASSIGNED',
  QE_DELETE_CASE_HAS_ORDER: 'QE_DELETE_CASE_HAS_ORDER',
  QUO_EDIT_LINKED_EVAL_OR_ORDER: 'QUO_EDIT_LINKED_EVAL_OR_ORDER',
  QUO_DELETE_CASE_ASSIGNED: 'QUO_DELETE_CASE_ASSIGNED',
  QUO_DELETE_LINKED_EVAL_OR_ORDER: 'QUO_DELETE_LINKED_EVAL_OR_ORDER',
  ENQ_EDIT_LINKED_QUOTATION: 'ENQ_EDIT_LINKED_QUOTATION',
  ENQ_DELETE_LINKED_QUOTATION: 'ENQ_DELETE_LINKED_QUOTATION',
  ENQ_DELETE_CASE_ASSIGNED: 'ENQ_DELETE_CASE_ASSIGNED',
  REQ_EDIT_AND_CREATE_ENQ_PIPELINE_LOCKED: 'REQ_EDIT_AND_CREATE_ENQ_PIPELINE_LOCKED',
} as const;

type SupplyBlockCode = typeof SUPPLY_BLOCK_CODES[keyof typeof SUPPLY_BLOCK_CODES];

const SUPPLY_BLOCK_MESSAGES: Record<SupplyBlockCode, string> = {
  PO_EDIT_FORWARDING: 'This purchase order cannot be edited because a forwarding is linked to it.',
  PO_EDIT_DELIVERY: 'This purchase order cannot be edited because a delivery is linked to it.',
  PO_EDIT_INVOICE: 'This purchase order cannot be edited because an invoice is linked to it.',
  PO_DELETE_CASE_ASSIGNED: 'This purchase order cannot be deleted while it is assigned to a spare case.',
  PO_DELETE_FORWARDING: 'This purchase order cannot be deleted because a forwarding is linked to it.',
  PO_DELETE_DELIVERY: 'This purchase order cannot be deleted because a delivery is linked to it.',
  PO_DELETE_INVOICE: 'This purchase order cannot be deleted because an invoice is linked to it.',
  PO_EDIT_CASE_LINKED_FLOW:
    'This purchase order cannot be edited because forwarding, delivery, or invoice already exists in this spare case.',
  FWD_DELETE_CASE_ASSIGNED: 'This forwarding cannot be deleted while it is assigned to a spare case.',
  FWD_DELETE_LINKED_ORDER_DELIVERIES:
    'This forwarding cannot be deleted because deliveries exist for its linked purchase order.',
  QE_EDIT_CASE_HAS_ORDER: 'This evaluation cannot be edited because a purchase order exists in this spare case.',
  QE_DELETE_CASE_ASSIGNED: 'This evaluation cannot be deleted while it is assigned to a spare case.',
  QE_DELETE_CASE_HAS_ORDER: 'This evaluation cannot be deleted because a purchase order exists in this spare case.',
  QUO_EDIT_LINKED_EVAL_OR_ORDER:
    'This quotation cannot be edited while it is linked to a quotation evaluation or purchase order.',
  QUO_DELETE_CASE_ASSIGNED: 'This quotation cannot be deleted while it is assigned to a spare case.',
  QUO_DELETE_LINKED_EVAL_OR_ORDER:
    'This quotation cannot be deleted while it is linked to a quotation evaluation or purchase order.',
  ENQ_EDIT_LINKED_QUOTATION:
    'This RFQ cannot be edited while a quotation is linked to it. Remove or delete the quotation first.',
  ENQ_DELETE_LINKED_QUOTATION:
    'This RFQ cannot be deleted while a quotation is linked to it. Remove or delete the quotation first.',
  ENQ_DELETE_CASE_ASSIGNED: 'This RFQ cannot be deleted while it is assigned to a spare case.',
  REQ_EDIT_AND_CREATE_ENQ_PIPELINE_LOCKED:
    'This requisition cannot be edited and cannot create a supplier enquiry because an enquiry, quotation, or purchase order is already linked.',
};

export function supplyBlockedActionMessage(code: SupplyBlockCode): string {
  return `[${code}] ${SUPPLY_BLOCK_MESSAGES[code]}`;
}

